import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiService } from '@shared/services/api.service';
import { DevelopmentApi } from '../models/development-api.model';
import { Development } from '../models/development.model';

export interface DevelopmentsFilter {
  isFavorite?: boolean;
  regionId?: string;
  projectId?: number;
  flagId?: number;
  q?: string;
  page?: number;
}

@Injectable({
  providedIn: 'root',
})
export class DevelopmentsApiService {

  static apiContext = 'enterprises';

  private _apiService = inject(ApiService);

  get$(filter?: DevelopmentsFilter): Observable<Development[] | null> {
    const url = filter
                ? `${ DevelopmentsApiService.apiContext }${ this._buildQuery(
            filter) }`
                : DevelopmentsApiService.apiContext;

    return this._apiService
               .get<DevelopmentApi[]>(url)
               .pipe(
                   map((items) => items
                                  ? items.map((item) => new Development(item))
                                  : null),
               );
  }

  getById$(id: number): Observable<Development | null> {
    return this._apiService
               .get<DevelopmentApi>(`${ DevelopmentsApiService.apiContext }/${ id }`)
               .pipe(
                   map((item) => item ? new Development(item) : null),
               );
  }

  toggleFavorite$(id: number): Observable<null> {
    return this._apiService
               .post({
                 url: `${ DevelopmentsApiService.apiContext }/${ id }/favorite`,
                 body: {},
               });
  }

  private _buildQuery(filter: DevelopmentsFilter): string {
    const params = new URLSearchParams();

    if (filter.isFavorite !== undefined) {
      params.set('is_favorite', String(filter.isFavorite));
    }
    if (filter.regionId) {
      params.set('region_id', String(filter.regionId));
    }
    if (filter.projectId !== undefined) {
      params.set('project_id', String(filter.projectId));
    }
    if (filter.flagId !== undefined) {
      params.set('flag_id', String(filter.flagId));
    }
    if (filter.q) {
      params.set('q', filter.q);
    }
    if (filter.page !== undefined) {
      params.set('page', String(filter.page));
    }

    const query = params.toString();
    return query ? `?${ query }` : '';
  }
}
